import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/LoginPage.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (email && password) {
      try {
        const response = await axios.post(
          'https://feemanagementsystem.oxfordconventschoolkhajuri.com/backend/api/login.php',
          {
            email: email,
            password: password,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
            withCredentials: true, // ✅ Important for session cookie
          }
        );

        console.log("Login response:", response);

        if (response.data.status === 'success') {
          localStorage.setItem('userEmail', email); // Optional: only if you need email
          navigate('/home');
        } else {
          alert(response.data.message);
        }
      } catch (error) {
        console.error('There was an error logging in!', error);
        alert('There was an error with the login request. Please try again.');
      }
    } else {
      alert('Please enter both email and password');
    }
  };

  return (
    <div className="lpx-container">
      <div className="lpx-content">
        <h1 className="lpx-header">Login</h1>
        <form onSubmit={handleLogin} className="login-form">
          <div className="lpx-input-group">
            <label htmlFor="email">Email ID</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>
          <div className="lpx-input-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>
          <button type="submit" className="lpx-button">Login</button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
